export default "__VITE_ASSET__Dn6gvAK6__"